<template>
   <div>
    <Tables :stickyHeader="true" ref="tableCollaborators"
              :columns="['Nome','Função','Último lote' ,'Início Última Viagem','Término Última Viagem','Valor Adiantamento','']"
              :showSearch="false"
              :showPrint="false"
              :showDownload="false"
              :showFullscreen="false"
              :newHeaderStatus="true"
              v-on:Load="Onload"
              :getShowDelete="true"
              :key="0"
            >
              <tr v-for="(collab,index) in collaboratorsArray" :key="index" >
                <TableColumn
                  :IsText="collab.dataDemissao == null"
                  :IsTextLocked="collab.dataDemissao !==null"
                  :IsLineThrough="collab.bloqueado"
                  :status="1"
                  :value="collab.nomeFuncionario"
                  v-on:Edit="redirectToCollaboratorDetails(collab.funcionarioId)"
                />
                <TableColumn
                  :IsText="collab.dataDemissao == null"
                  :IsTextLocked="collab.dataDemissao !==null"
                  :IsLineThrough="collab.bloqueado"
                  :status="1"
                  :value="collab.cargo"
                  v-on:Edit="redirectToCollaboratorDetails(collab.funcionarioId)"
                />
                <TableColumn
                :IsText="collab.dataDemissao == null"
                  :IsTextLocked="collab.dataDemissao !==null"
                  :IsLineThrough="collab.bloqueado"
                  :status="1"
                  :value="collab.lote"
                  v-on:Edit="redirectToCollaboratorDetails(collab.funcionarioId)"
                />
                <TableColumn
                :IsText="collab.dataDemissao == null"
                  :IsTextLocked="collab.dataDemissao !==null"
                  :IsLineThrough="collab.bloqueado"
                  :status="1"
                  :value="formataData(collab.dataInicio)"
                  v-on:Edit="redirectToCollaboratorDetails(collab.funcionarioId)"
                />
                <TableColumn
                :IsText="collab.dataDemissao == null"
                  :IsTextLocked="collab.dataDemissao !==null"
                  :IsLineThrough="collab.bloqueado"
                  :status="1"
                  :value="formataData(collab.dataFim)"
                  v-on:Edit="redirectToCollaboratorDetails(collab.funcionarioId)"
                />
                <TableColumn
                  :IsText="collab.dataDemissao == null"
                  :IsTextLocked="collab.dataDemissao !==null"
                  :IsLineThrough="collab.bloqueado"
                  :status="1"
                  :value="formatMoney(collab.valorAdiantamneto == null ? 0 : collab.valorAdiantamneto)"
                  v-on:Edit="redirectToCollaboratorDetails(collab.funcionarioId)"
                />
                <!-- ZC-32: o botao de Reforco (:IsReinforcementTravel / v-on:ReinforcementTravel) saiu
                     daqui. Em Viagem nao existe reforco de despesa: o que existe e a edicao de
                     adiantamento, que ja materializa a reducao em CRUDDespesasViagem.CriaReforcoDeReducao.
                     Estava quebrado desde o commit d13e07d78 (07/12/2023), que passou a ler file.Name fora
                     do guard: qualquer clique respondia 400 (NRE), porque tableReinforcement() monta o
                     FormData so com "reforco". Em producao ha 1 unico reforco de Viagem, de 28/09/2023 —
                     anterior ao commit — contra 370 de Diversos. Ninguem abriu chamado em 2 anos e meio.
                     Nao bastava destravar o back: PostReforco grava Reforco{Status=1, UltimoReforco=true},
                     que CRUDDespesasViagem:997 SOMA em totalGastar na aprovacao da diretoria — teto maior
                     sem despesa de aprovacao nenhuma (ela so nasce if Diversos == true).
                     O modal reinforcement-despesa e seus metodos ficaram sem ponto de entrada. -->
                <TableColumn
                  :IsLockUnlock="!isConsulta && hasRole(roles.ACC_FIN_TRAVELLANEOUS_SEARCH_CONTROLLER_APPROVAL)"
                  :IsActiveButton="!isConsulta && hasRole(roles.ACC_FIN_TRAVELLANEOUS_SEARCH_CONTROLLER_APPROVAL)"
                  :newEditGama="!isConsulta && hasRole(roles.ACC_FIN_TRAVELLANEOUS_SEARCH_CONTROLLER_APPROVAL)"
                  :HasDelete="false"
                  v-on:Delete="openModalDelete(collab)"
                  v-on:Edit="openModalEdit(collab)"
                  v-on:Lock="ModalLock(collab)"
                  v-on:DeletePopup="openDeletePopup(collab)"
                  :IsLocked="!collab.bloqueado"
                  :deletePopup="true"
                />
              </tr>
              <template v-if="!isConsulta && hasRole(roles.ACC_FIN_TRAVELLANEOUS_SEARCH_CONTROLLER_APPROVAL)" #ButtonsAprova>
                  <div class="w-100 btn-geralote-add">
                    <!-- <travelexpense ref="travelexpense">
                    </travelexpense> -->
                     <!-- <button class="btn-generate-lote" @click="gerarLote"><i class="fas fa-file-excel mr-1"/>GERAR LOTE</button> -->
                    <button @click="openModal" class="btn-head"><i class="fas fa-plus"></i></button>
                  </div>
              </template>
    </Tables>
      <b-modal ref="add-despesa"
      size="md"
      centered
      id="add-brower-modal-conta"
      title="CADASTRAR NOVA DESPESA VIAGEM"
      :hide-footer="true"
      :clickToClose="false"
      :no-close-on-backdrop="true"
      :no-close-on-esc="true"
      :hide-header-close="true"
      >
      <div class="title-1">Dados Básicos</div>
            <div class="container-user-form">
          <b-form-group
            id="input-group-nome-colaborador"
            label="Nome *"
            label-for="input-nome-colaborador"
            placeholder="Selecione"
          >
          <autocomplete-z ref="favorecidoTypeaheadPoup"
              placeholder="Digite nome do funcionario"
              iconClass="fas fa-id-badge"
              :serializer="(favorecido) => favorecido.nome"
              :debounceLength="3"
              :formField="formAddDe.objnomeFuncionarios"
              v-on:search="onSearchFavorecido"
              v-on:changeCode="onChangeCodeFavorecido"
              v-on:hit="GetCargobyId"
              />
          </b-form-group>
         <b-form-group
            id="input-group-funcao"
            label="Função *"
            label-for="input-funcao"
          >
          <div class="input-funcao-cargo" id="cargoSelecionado">
            <b-form-input
                id="input-funcao"
                name="input-funcao"
                type="text"
                placeholder="Função"
                v-model="nomeCargo"
                :disabled="disableDados == true"
              >
              </b-form-input>
          </div>

            <div  class="input-funcao-cargo-bloc" id="cargo">
              <autocomplete-z ref="favorecidooTypeaheadPoup"
                placeholder="Digite nome do cargo"
                :serializer="(cargo) => cargo.nome"
                :debounceLength="4"
                :ShowCode="false"
                :formField="nomeCargo"
                v-on:search="onSearchCargo"
                v-on:hit="getcargoId"
              />
            </div>

          <b-form-checkbox
            class="mt-2"
            id="checkbox-1"
            v-model="formAddDe.saldo"
            name="checkbox-1"
            :value="true"
            :unchecked-value="false">
            Possui Saldo Existente?
          </b-form-checkbox>
          <money
            v-if="formAddDe.saldo"
            v-model="formAddDe.saldoValor"
            class="form-control form-control-10"
            v-bind="moneyOpts"
            :placeholder="'0'"
          />

         </b-form-group>
         <b-form-group
            id="input-group-valorAdiantamento"
            label="Valor Adiantamento:"
            label-for="input-valorAdiantamento"
          >
            <select class="form-control" v-model="formAddDe.Adiantamento">
               <option :value="null" disabled>{{ 'Selecione um valor de adiantamento' }}</option>
               <!-- <option v-for="data in valorAdiantamentoEnum" :key="data.value" :value="data.value">{{data.text}}</option> -->
               <option v-for="data in filteredValorAdiantamentoEnum" :key="data.value" :value="data.value">{{data.text}}</option>
            </select>
          </b-form-group>
         <div class="container-buttons-form pt-3">
          <button @click="cancelNewBrower" class="button-cancel">
            Cancelar
          </button>
          <button @click="AdicionarFuncionario(funcionarioId)" class="button-save">Salvar</button>
         </div>
    </div>
   </b-modal>

   <b-modal ref="add-conta"
      size="md"
      centered
      id="add-brower-modal"
      title="CADASTRAR UMA NOVA CONTA"
      :hide-footer="true"
      :clickToClose="false"
      :no-close-on-backdrop="true"
      :no-close-on-esc="true"
      :hide-header-close="true"
   >
      <div>
        <div class="flex">
         <div class="campo">
            <b-form-group
               id="input-group-name-accountid"
               label="Nome *"
               label-for="input-name-accountid"
            >
            <b-form-input
              id="input-name-accountid"
              name="input-name-accountid"
              type="text"
              v-model="formAddDe.objnomeFuncionarios"
              placeholder="Nome"
            ></b-form-input>
             </b-form-group>
         </div>
            <div class="campo">
               <b-form-group
                  id="input-group-name-accountid"
                  label="Telefone *"
                  label-for="input-name-accountid"
               >
               <b-form-input
               id="input-name-accountid"
               name="input-name-accountid"
               placeholder="Contato"
               v-model="formAddDe.TelefoneCelular"
               v-validate="{ required: true, numeric: false, length:14 }"
               v-mask="['(##) #####-####']"
               ></b-form-input>
               </b-form-group>
            </div>
        </div>

        <div class="flex">
          <div class="campo">
               <b-form-group
                  id="input-group-name-accountid"
                  label="Username *"
                  label-for="input-name-accountid"
               >
                  <b-form-input
                  id="input-name-accountid"
                  name="input-name-accountid"
                  type="text"
                  v-model="formAddDe.Username"
                  placeholder="Username"
                  ></b-form-input>
               </b-form-group>
          </div>
        </div>

        <div class="flex">
            <div class="campo">
               <b-form-group
                  id="input-group-name-accountid"
                  label="Senha *"
                  label-for="input-name-accountid"
               >
                  <b-form-input
                  v-model="formAddDe.Senha"
                  id="input-name-accountid"
                  name="input-name-accountid"
                  type="password"
                  placeholder="Senha"
                  ></b-form-input>
               </b-form-group>
            </div>
            <div class="campo">
               <b-form-group
                     id="input-group-name-accountid"
                     label="Confirmar Senha"
                     label-for="input-name-accountid"
                  >
                     <b-form-input
                     v-model="formAddDe.ConfSenha"
                     id="input-name-accountid"
                     name="input-name-accountid"
                     type="password"
                     placeholder="Confirme a Senha"
                     ></b-form-input>
               </b-form-group>
            </div>
        </div>

        <b-form-group
            id="input-group-name-accountid"
            label="Email *"
            label-for="input-name-accountid"
          >
            <b-form-input
              v-model="formAddDe.Email"
              id="input-name-accountid"
              name="input-name-accountid"
              type="text"
              placeholder="Email"
            ></b-form-input>
        </b-form-group>
    </div>
      <div class="container-buttons-form pt-3">
        <button @click="voltar" class="button-cancel">
          Voltar
        </button>
        <button class="button-save" @click="verificaConfSenha(funcionarioId == null ? formAddDe.funcionarioId :  funcionarioId)">Salvar</button>
      </div>
   </b-modal>

   <b-modal ref="edit-despesa"
      size="sm"
      centered
      id="edit-brower-modal-conta"
      title="EDITAR DESPESA VIAGEM"
      :hide-footer="true"
      :clickToClose="false"
      :no-close-on-backdrop="true"
      :no-close-on-esc="true"
      >
      <div class="columnchamado">
        <div >
          <div class="label mb-2">
              Código - Nome
          </div>
            <p class="value">
               {{editinfo.codigo}} - {{editinfo.nomeFuncionario}}
            </p>
        </div>
        <div>
          <div class="label mb-2">
              Função
          </div>
          <p class="value">
               {{editinfo.cargo !== null && editinfo.cargo !== undefined ? editinfo.cargo : 'N/D'}}
          </p>
        </div>
        <div>
          <div class="label mb-2">
              Último Lote Despesas
          </div>
          <p class="value">
               {{editinfo.lote == 0 ? 'N/D' : editinfo.lote}}
          </p>
        </div>
        <!-- <div v-if="this.ObjLoteNovoFuncionario.length > 0">
          <div class="label mb-2">
              Primeiro Lote Funcionário
          </div>
          <p class="value">
               {{this.ObjLoteNovoFuncionario[0]}}
          </p>
        </div> -->
        <!-- <div>
          <div class="label mb-2">
              Inicio Última Viagem
          </div>
        </div>
        <div class="edit-expense">
          <div class="label mb-2">
              Término Ultima Viagem
          </div>
          <div>
          <p class="value">
               {{editinfo.dataFim}}
          </p>
          </div>
        </div> -->
      <b-form-group
        id="input-group-valorAdiantamento"
        label="Valor Adiantamento:"
        label-for="input-valorAdiantamento"
        class="label mb-2"
      >

      <select class="form-control" v-model="editinfo2.Adiantamento" >
        <option :value="null">{{ 'Selecione..' }}</option>
        <!-- <option v-for="data in valorAdiantamentoEnum" :key="data.value" :value="data.value">{{ data.text }}</option> -->
        <option v-for="data in filteredValorAdiantamentoEnum" :key="data.value" :value="data.value">{{ data.text }}</option>
      </select>
      </b-form-group>

      <!-- ZC-33: so aparece DEPOIS que o backend recusa a edicao por base incompleta (primeiro
           adiantamento lancado com valor zero e sem linha de saldo). Quem decide se este colaborador
           precisa declarar e o backend, nao a tela: `Saldo`/`SaldoValor` sao lidos num unico ponto
           do fluxo de Viagem, entao mostrar o par pra todo mundo seria no-op silencioso — marcar,
           salvar e receber "Edicao feita com sucesso" sem nada ter sido gravado. -->
      <div v-if="saldoPendente" class="mt-2">
        <b-form-checkbox
          id="checkbox-saldo-edicao"
          v-model="editinfo2.Saldo"
          name="checkbox-saldo-edicao"
          :value="true"
          :unchecked-value="false"
          @change="editinfo2.ConfirmaSemSaldoExistente = false">
          Possui Saldo Existente?
        </b-form-checkbox>
        <money
          v-if="editinfo2.Saldo"
          v-model="editinfo2.SaldoValor"
          class="form-control form-control-10"
          v-bind="moneyOpts"
          :placeholder="'0'"
        />
        <!-- A confirmacao e campo proprio porque `Saldo = false` nao distingue "nao tem saldo" de
             "nao mexeu no checkbox", e essa diferenca e o que separa quem foi cadastrado com saldo
             de quem escolheu o adiantamento "R$ 0,00", opcao legitima do select acima. -->
        <b-form-checkbox
          v-if="!editinfo2.Saldo"
          class="mt-2"
          id="checkbox-sem-saldo-edicao"
          v-model="editinfo2.ConfirmaSemSaldoExistente"
          name="checkbox-sem-saldo-edicao"
          :value="true"
          :unchecked-value="false">
          Confirmo que este colaborador não possui saldo existente
        </b-form-checkbox>
      </div>
        </div>
        <div class="container-buttons-form pt-3">
        <button @click="cancelEditBrower" class="button-cancel">
          Voltar
        </button>
        <button @click="EditaAdiantamento(editinfo.funcionarioId)" class="button-save">Salvar</button>
      </div>
    </b-modal>
    <b-modal ref="DetailsLock"
              hide-footer
              centered
              :title="objColaborador.bloqueado == false ? 'BLOQUEAR' : 'DESBLOQUEAR'"
              size="md">
            <div v-if="objColaborador.bloqueado == false">
              <b-form-group
                id="input-lock"
                label="Motivo do bloqueio *"
                label-for="input-input-lock"
              >
                <b-form-textarea
                  v-model="PopupmotivoBloqueio"
                  id="input-motivoBloqueio"
                  name="input-motivoBloqueio"
                  type="text"
                  placeholder="Motivo do bloqueio"
                ></b-form-textarea>
              </b-form-group>
            </div>
            <div v-else>
              <div class="desbloquear">
                <i class="fas fa-unlock icon-unlock"></i>
              </div>
              <div class="font-unlock">Deseja desbloquear esse usuário ?</div>
            </div>
            <div class="container-buttons-form pt-3">
              <button @click="CloseModalLock" class="button-cancel">
                {{objColaborador.bloqueado == false ? 'Cancelar' : 'Não'}}
              </button>
              <button @click="LockCollaborator(obj)" class="button-save">{{objColaborador.bloqueado == false ? 'Salvar' : 'Sim'}}</button>
            </div>
    </b-modal>

    <b-modal
        hide-footer
        centered
        :clickToClose="false"
        size="md"
        ref="add-travel-modal-erro"
        id="add-travel-modal"
        title="Adicionar novo documento">
        <template #modal-header>
            <div class="head-modal-error" v-if="exclusao == false">
                <p id="title-modal-cus" class="erroPoUp">Funcionário Impossibilitado Para Cadastro Temporariamente</p>
            </div>
            <div class="head-modal-error" v-if="exclusao == true">
                <p id="title-modal-cus" class="erroPoUp">Funcionário Impossibilitado Para Exclusão</p>
            </div>
        </template>
          <div v-if="ArrayFuncionarioImpossibilitado !== 0">
            <div v-if="ArrayFuncionarioImpossibilitado.despesa != null">
              <div class="corpofluxo" v-if="ArrayFuncionarioImpossibilitado.despesa[0].fluxo == 'Reembolso Viagem - Prestação de Conta'">
                   <div class="fluxo_corpo">
                      <div class="fluxo_label_fluxo">
                          {{ArrayFuncionarioImpossibilitado.despesa[0].fluxo}}
                      </div>
                  </div>
                  <div class="fluxo_corpo">
                      <div class="fluxo_icone">
                          <i class="fa fa-user-circle" aria-hidden="true"></i>
                      </div>
                      <div class="fluxo_label">
                          Funcionário: {{ArrayFuncionarioImpossibilitado.despesa[0].codigo}} - {{ArrayFuncionarioImpossibilitado.despesa[0].nomeFuncionario}}
                      </div>
                  </div>

                  <div class="fluxo_corpo">
                      <div class="fluxo_icone">
                          <i class="fas fa-money-check" aria-hidden="true"></i>
                      </div>
                      <div class="fluxo_label">
                           Valor: {{formatMoney(ArrayFuncionarioImpossibilitado.despesa[0].valorGasto)}}
                      </div>
                  </div>
              </div>
            </div>
            <div v-if="ArrayFuncionarioImpossibilitado.termoAceite != null">
              <div class="corpofluxo"  v-if="ArrayFuncionarioImpossibilitado.termoAceite[0].fluxo == 'Reembolso Viagem - Adiantamento'">
                  <div class="fluxo_corpo" >
                      <div class="fluxo_label_fluxo">
                           {{ArrayFuncionarioImpossibilitado.termoAceite[0].fluxo}}
                      </div>
                  </div>

                  <div class="fluxo_corpo">
                      <div class="fluxo_icone">
                          <i class="fa fa-user-circle" aria-hidden="true"></i>
                      </div>
                      <div class="fluxo_label">
                           Funcionário: {{ArrayFuncionarioImpossibilitado.termoAceite[0].codigo}} - {{ArrayFuncionarioImpossibilitado.termoAceite[0].nomeFuncionario}}
                      </div>
                  </div>

                  <div class="fluxo_corpo">
                      <div class="fluxo_icone">
                         <i class="fas fa-money-check" aria-hidden="true"></i>
                      </div>
                      <div class="fluxo_label">
                          Valor: {{formatMoney(ArrayFuncionarioImpossibilitado.termoAceite[0].valorGasto)}}
                      </div>
                  </div>
              </div>
            </div>
             <div v-if="ArrayFuncionarioImpossibilitado.despesasDiversos != null">
              <div class="corpofluxo" v-if="ArrayFuncionarioImpossibilitado.despesasDiversos[0].fluxo == 'Despesas Diversos'">
                  <div class="fluxo_corpo">
                      <div class="fluxo_label_fluxo">
                          {{ArrayFuncionarioImpossibilitado.despesasDiversos[0].fluxo}}
                      </div>
                  </div>

                  <div class="fluxo_corpo">
                      <div class="fluxo_icone">
                         <i class="fa fa-user-circle" aria-hidden="true"></i>
                      </div>
                      <div class="fluxo_label">
                         Funcionário:{{ArrayFuncionarioImpossibilitado.despesasDiversos[0].codigo}} - {{ArrayFuncionarioImpossibilitado.despesasDiversos[0].nomeFuncionario}}
                      </div>
                  </div>

                  <div class="fluxo_corpo">
                      <div class="fluxo_icone">
                          <i class="fa fa-money-check" aria-hidden="true"></i>
                      </div>
                      <div class="fluxo_label">
                          Valor: {{formatMoney(ArrayFuncionarioImpossibilitado.despesasDiversos[0].valorGasto)}}
                      </div>
                  </div>
              </div>
            </div>
            <div v-if="ArrayFuncionarioImpossibilitado.despesasViagem != null">
            <div class="corpofluxo" v-if="ArrayFuncionarioImpossibilitado.despesasViagem[0].fluxo == 'Despesas Viagem'">
                  <div class="fluxo_corpo">
                      <div class="fluxo_label_fluxo">
                          {{ArrayFuncionarioImpossibilitado.despesasViagem[0].fluxo}}
                      </div>
                  </div>

                  <div class="fluxo_corpo">
                      <div class="fluxo_icone">
                          <i class="fa fa-user-circle" aria-hidden="true"></i>
                      </div>
                      <div class="fluxo_label">
                         Funcionário: {{ArrayFuncionarioImpossibilitado.despesasViagem[0].nomeFuncionario}}
                      </div>
                  </div>

                  <div class="fluxo_corpo">
                     <div class="fluxo_icone">
                          <i class="fa fa-money-check" aria-hidden="true"></i>
                      </div>
                      <div class="fluxo_label">
                          Valor: {{formatMoney(ArrayFuncionarioImpossibilitado.despesasViagem[0].valorGasto)}}
                      </div>
                  </div>
              </div>
            </div>
              <div class="fluxo_corpo_aviso">
                  <div class="fluxo_icone_menssagem">
                     <i class="fa fa-exclamation-triangle" aria-hidden="true"></i>
                  </div>
                  <div class="fluxo_label_menssagem">
                      Por favor regularize a situação do funcionário para criar novas despesas!
                  </div>
              </div>
          </div>
          <div else></div>
        </b-modal>
        <b-modal ref="warning-support"
          class="d-flex"
          size="sm"
          centered
          id="add-brower-modal-warning"
          title="Aviso!"
          :hide-footer="true"
          :clickToClose="false"
          :hide-header-close="true"
          >
          <div class="d-flex flex-column gap-6">
            <div class="d-flex title-1">
              <div class="d-flex flex-column justify-content-center align-items-center mb-2">
                <i class="fa fa-exclamation-triangle mb-2 icon-attention" aria-hidden="true"></i>
                <div class="mb-4 attention-text">Atenção!</div>
                <span>Funcionário sem conta vinculada
                  Contate a equipe de T.I.</span>
              </div>
            </div>
            <div class="container-buttons-form">
                <button @click="$refs['warning-support'].hide()" class="button-save">Voltar</button>
            </div>
          </div>
        </b-modal>
        <b-modal ref="reinforcement-despesa"
      size="lg"
      centered
      id="reinforcement-brower-modal-conta"
      title="REFORÇAR DESPESA"
      :hide-footer="true"
      :clickToClose="false"
      :no-close-on-backdrop="true"
      :no-close-on-esc="true"
      >
      <div class="columnchamado">
        <!-- <div class="d-flex flex-column">
          <div class="d-flex flex-column">
            <div class="label">
              Código - Nome :
            </div>
            <p class="value">
              {{editinfo.funcionario !== null && editinfo.funcionario !== undefined ? editinfo.funcionario.nome : 'N/D'}}
            </p>
          </div>
          <div class="d-flex flex-column">
            <div class="label">
              Função :
            </div>
            <p class="value">
              {{editinfo.funcionario.cargo.nome !== null && editinfo.funcionario.cargo.nome !== undefined ? editinfo.funcionario.cargo.nome : 'N/D'}}
            </p>
          </div>
        </div> -->
        <Tables ref="TabledetailsTabReforco"
                  :columns="['Valor','Data Inclusão','Status', '']"
                  :key="0"
                  v-on:tableMounted="GetReforco()"
                  :newHeaderStatus="true"
                >
                  <tr v-for="detail in details" :key="detail.valorReforco" >
                    <TableColumn
                      :IsText="true"
                      :value="formatMoney(detail.valorReforco == null ? 0 : detail.valorReforco)"
                    />
                    <TableColumn
                      :IsText="true"
                      :status="1"
                      :value="detail.dataAcaoFormatada"
                    />
                    <TableColumn
                      :IsText="true"
                      :status="1"
                      :value="(detail.status == 1 ? 'Ativo' : 'Inativo')"
                    />
                    <TableColumn
                  :IsActiveButton="!isConsulta && hasRole(roles.ACC_FIN_TRAVELREFUND_SEARCH_CONTROLLER_APPROVAL)"
                  :newEditGama="!isConsulta && hasRole(roles.ACC_FIN_TRAVELREFUND_SEARCH_CONTROLLER_APPROVAL)"
                  :HasChange="!isConsulta && hasRole(roles.ACC_FIN_TRAVELREFUND_SEARCH_CONTROLLER_APPROVAL)"
                  v-on:Delete="openModalDeleteReforco(detail)"
                  v-on:Edit="openModalReinforcementEdit(detail)"
                  />
                </tr>
                <template v-if="!isConsulta && hasRole(roles.ACC_FIN_TRAVELREFUND_SEARCH_CONTROLLER_APPROVAL)" #ButtonsAprova>
                  <div class="w-100">
                    <button class="btn-head" @click="openModalReinforcementValue(detail)"><i class="fas fa-plus"></i></button>
                  </div>
              </template>
        </Tables>
        </div>
        <div class="container-buttons-form pt-3">
          <button @click="cancelReinforcementBrower" class="button-cancel">
            Voltar
          </button>
        </div>
    </b-modal>
    <b-modal ref="reinforcement-despesa-value"
      size="sm"
      centered
      id="reinforcement-despesa-value-brower-modal"
      title="ADICIONAR REFORÇO DE DESPESA"
      :hide-footer="true"
      :clickToClose="false"
      :no-close-on-backdrop="true"
      :no-close-on-esc="true"
      >
      <div class="columnchamado">
        <div class="d-flex">
          <div class="d-flex">
            <div class="label">
              Valor do Reforço
            </div>
            <money
              v-if="GetLocalidade() === 'escl'"
              v-model="dataReforco.valorReforco"
              class="form-control form-control-10"
              v-bind="moneyFormat"
              :placeholder="'0'"
              prefix="$ "/>
            <money
              v-if="GetLocalidade() !== 'escl'"
              v-model="dataReforco.valorReforco"
              class="form-control form-control-10"
              v-bind="moneyFormat"
              :placeholder="'R$ 0,00'"
              prefix="R$ "/>
          </div>
        </div>
      </div>
      <div class="container-buttons-form pt-3">
        <button @click="cancelReinforcementValue" class="button-cancel">
            Voltar
          </button>
          <button class="button-save" @click="tableReinforcement">Salvar</button>
      </div>
    </b-modal>
    <b-modal ref="reinforcement-despesa-edit"
      size="sm"
      centered
      id="reinforcement-despesa-edit-brower-modal"
      title="EDITAR REFORÇO DE DESPESA"
      :hide-footer="true"
      :clickToClose="false"
      :no-close-on-backdrop="true"
      :no-close-on-esc="true"
      >
      <div class="columnchamado">
        <div class="d-flex">
          <div class="d-flex">
            <div class="label">
              Valor do Reforço
            </div>
            <money
            v-if="GetLocalidade() === 'escl'"
            v-model="reforcoEdit"
            class="form-control form-control-10"
            v-bind="moneyFormat"
            :placeholder="'0'"
            prefix="$ "
            />
            <money
            v-if="GetLocalidade() !== 'escl'"
              v-model="reforcoEdit"
              class="form-control form-control-10"
              v-bind="moneyFormat"
              :placeholder="'R$ 0,00'"
              prefix="R$ "/>
          </div>
        </div>
      </div>
      <div class="container-buttons-form pt-3">
        <button @click="cancelReinforcementEdit" class="button-cancel">
            Voltar
          </button>
          <button class="button-save" @click="EditaReforco">Salvar</button>
      </div>
    </b-modal>
    <b-modal ref="delete-despesa"
      size="md"
      centered
      id="delete-despesa-popup-brower-modal"
      title="DELETAR DESPESA"
      :hide-footer="true"
      :clickToClose="false"
      :no-close-on-backdrop="true"
      :no-close-on-esc="true"
      >
      <div class="columnchamado">
        <div class="d-flex warning-delete mb-3">
          <div class="sign mb-2">
            <i class="fa fa-exclamation-triangle" aria-hidden="true" style="color:#008148"></i>
          </div>
          <div class="text-confirm">
            Confirmar Exclusão?
          </div>
        </div>
        <div class="deleteExpense mb-2">
          <div class="travel-dates">
            <div class="w-50">
              <div class="title-delete">Codigo:</div>
              <div>{{ deletingColaborators.codigo }}</div>
            </div>
            <div class="w-50">
              <div class="title-delete">Nome:</div>
              <div>{{ deletingColaborators.nomeFuncionario }}</div>
            </div>
          </div>
          <div class="travel-dates">
            <div class="w-30">
              <div class="title-delete">Função:</div>
              <div>{{ deletingColaborators.cargo }}</div>
            </div>
            <div class="w-30">
              <div class="title-delete">Último Lote:</div>
              <div>{{ deletingColaborators.lote}}</div>
            </div>
            <div class="w-30">
              <div class="title-delete">Valor Adiantamento:</div>
              <div>{{ formatMoney(deletingColaborators.valorAdiantamneto == null ? 0 : deletingColaborators.valorAdiantamneto) }}</div>
            </div>
          </div>
          <div class="travel-dates">
            <div class="w-50">
              <div class="title-delete">Inicio Última Viagem:</div>
              <div>{{ formataData(deletingColaborators.dataInicio) }}</div>
            </div>
            <div class="w-50">
              <div class="title-delete">Término Ultima Viagem:</div>
              <div>{{ formataData(deletingColaborators.dataFim) }}</div>
            </div>
          </div>
        </div>
      </div>
      <div class="container-buttons-form pt-3">
        <button @click="cancelDeletepopup" class="button-no">
            Não
          </button>
          <button class="button-save" @click="ConfirmDelete">Sim</button>
      </div>
    </b-modal>
  </div>
</template>
<script>
import CollaboratorTableTravelExpense from './CollaboratorTableTravelExpense'
export default CollaboratorTableTravelExpense

</script>
<style scoped>
  .desbloquear{
    display: flex;
    justify-content: center;
    margin: 1rem;
  }
  .icon-unlock{
    font-size: 50px;
    color: #008144;
  }
  .font-unlock{
    font-size: 16px;
    color: #7c7c7c;
    text-align: center;
  }
  .head-modal-error{
    display: flex;
    justify-content: center;
  }
  .erroPoUp {
    color: white !important;
    font-size: 16px !important;
    line-height: 1.5rem;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .corpofluxo{
    padding: 1rem;
    display: flex;
    background: #dddddd73;
    border-radius: 11px;
    margin-bottom: 1rem;
    gap: 1rem;
    flex-direction: column;
  }
  .fluxo_label_menssagem{
    font-size: 15px;
    font-weight: bold;
  }

  .fluxo_label{
    font-size: 15px;
  }
  .fluxo_label_fluxo{
  font-size: 15px;
  font-weight: bold;
  color: #046437
  }

  .fluxo_icone_menssagem{
    font-size: 25px;
    color: #046437
  }
  .fluxo_icone{
    font-size: 20px;
    width: 2rem;
    color: #046437
  }
  .fluxo_corpo_aviso{
    padding: 1rem;
    align-items: center;
    display: flex;
    justify-content: initial;
    gap: 1rem;
    border: 2px dashed #046437;
  }

  .fluxo_corpo{
    align-items: center;
    display: flex;
    justify-content: initial;
    gap: 1rem;
  }
.btn-generate-lote {
    height: 2rem;
    width: 10rem;
    background: #008144;
    color: white;
    border-radius: 8px;
    border: none;
    font-weight: bold;
    display: flex;
    justify-content: center;
    align-items: center;
}
.btn-generate-lote:hover{
   background: #024d2a;
}

.display-flex{
      display: flex;
    column-gap: 1rem;
}
.campo{
 width: 100%;
}
.flex{
  display: flex;
  justify-content: center;
  width: 100%;
  column-gap: 1rem;
}

.formAddNome{
  grid-area: 1 / 1 / 2 / 3;
}

.formAddSenha{
  grid-area: 2 / 1 / 3 / 1;
}

.formAddConfsenha{
  grid-area: 2 / 2 / 3 / 3;
}
.formAddContato{
  grid-area: 3 / 1 / 4 / 2;
}
.formAddGrupo{
  grid-area: 3 / 2 / 4 / 3;
}

.formAddEmail{
  grid-area: 4 / 1 / 5 / 3;
}

.formAddUsername {
  grid-area: 5 / 1 / 6 / 3;
}

.label{
  font-weight: bold;
}

.d-flex{
  display: flex;
  flex-direction: column;
}

.columnchamado{
  display: flex;
  flex-direction: column;
}

.input-funcao-cargo{
  display: none;
}
.input-funcao-cargo-bloc{
  display: block;
}

 .container-buttons-form{
    display: flex;
    justify-content: center;
    align-items: center;
    gap:15px;
  }

  .container-buttons-form{
      grid-row: 8;
      grid-column: 1/11;
  }

  .button-cancel,
  .button-save{
    outline: transparent;
    border: transparent;
    border-radius: 4px;
    text-transform: uppercase;
    width: 190px;
    height: 40px;
  }
  .button-cancel{
    background-color: #dedede;
    color: #747474;
  }
  .button-save{
    background-color: #008148;
    color: white;
  }

  .btn-head{
  background-color: #008148;
  color: white;
  border: none;
  width: 3rem;
  font-weight: bold;
  height: 2rem;
  font-size: 20px;
  border-radius: 6px;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 0;
}

.title-1{
  padding-bottom: 2rem;
  font-size: 16px;
}

.container-user-form{
    display: flex;
    column-gap: 10px;
    row-gap: 10px;
    justify-content: center;
    flex-direction:column;
}

.btn-geralote-add{
  /* margin: 0.3rem; */
  display: flex;
  align-items: center;
  height: 100%;
  /* gap: 1rem; */
}
.icon-attention{
    font-size: 60px;
    padding: 1rem;
    color: #008144;
  }
  .attention-text {
    font-size:26px;
    font-weight: bold;
  }

  .deleteExpense{
  display: flex;
  gap: 1.5rem;
  flex-direction: column;
}
.sign{
  font-size: 60px;
}
  .travel-dates{
    display:flex;
    flex-direction: row;
    justify-content: space-between;
  }
.title-delete{
    font-weight: bold;
  }
  .warning-delete {
    align-items: center;
    flex-direction: column;
  }
  .text-confirm {
    font-size: 20px;
  }

  .button-no{
    outline: transparent;
    border: transparent;
    border-radius: 4px;
    text-transform: uppercase;
    width: 190px;
    height: 40px;
    background-color:red;
    color: white;
  }

</style>



// WEBPACK FOOTER //
// src/views/private/finance/expenses/travelexpensezpag/components/Tabs/CollaboratorTableTravelExpense/CollaboratorTableTravelExpense.vue